import React from 'react'
import { connect } from 'react-redux'
import { editSets } from "../../actions/settings"
import Select from 'react-select'
import DeleteConfirmation from '../ui/DeleteConfirmation'
import SettingsItemForm from './SettingsItemForm'

class SetsPercItem extends SettingsItemForm {

  modelName = 'perc'

  render() {
    const { data } = this.props;
    const { data: nData, errors } = this.state;

    const delConf = this.state.delConf ?
      <DeleteConfirmation
        onDelete={this.deleteItem}
        onCancel={this.toggleDelConf}
      />
      :
      '';

    if(this.state.editing){
      return(
        <tr>
          <td>
          {delConf}
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.perc_desc}
                name="perc_desc"
                onChange={this.updateInput}
                placeholder="Название"
                autoFocus
              />
            </div>
            <div className="form-inline">
              <button  type="button" className="btn btn-success"
                onClick={this.saveItem} title="Сохранить">
                <span className="glyphicon glyphicon-save"></span>
              </button>{" "}
              <button type="button" className="btn btn-default"
                onClick={this.cancelEditing} title="Отменить">
                <span className="glyphicon glyphicon-remove"></span>
              </button>{" "}
              <button type="button" className="btn btn-danger"
                onClick={this.toggleDelConf} title="Удалить">
                <span className="glyphicon glyphicon-trash"></span>
              </button>
            </div>
            {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          </td>
          <td>
            <input type="text"
              className="form-control"
              value={nData.perc_perc}
              name="perc_perc"
              onChange={this.updateInput}
              placeholder="Процент"
            />
          </td>
          <td>
            <Select
              clearable={false}
              options={[{value:1,label:'Надбавка'},{value:-1,label:'Скидка'}]}
              value={nData.perc_type}
              onChange={e => this.updateSelect(e,'perc_type')}
              placeholder="Тип корректировки"
            />
          </td>
          <td>
            <input type="text"
              className="form-control"
              value={nData.perc_text}
              name="perc_text"
              onChange={this.updateInput}
              placeholder="Описание"
            />
          </td>
        </tr>
      );
    }
    else{
      return (
        <tr onClick={this.startEditing}>
          <td>{data.perc_desc}</td>
          <td>{data.perc_perc}</td>
          <td>{data.perc_type === 1 ? 'Надбавка' : 'Скидка'}</td>
          <td>{data.perc_text}</td>
        </tr>
      );
    }

  }
}

export default connect(null, { editSets })(SetsPercItem);



// WEBPACK FOOTER //
// ./src/components/settings/SetsPercItem.js